// extracted by mini-css-extract-plugin
export default {"collapseContein":"Colapse_collapseContein__I7BbF","break":"Colapse_break__AS2E2"};